"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MyContext = void 0;
exports["default"] = Menu;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _Popper = _interopRequireDefault(require("@material-ui/core/Popper"));
var _react = _interopRequireDefault(require("react"));
var _reactSelect = require("react-select");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var MyContext = /*#__PURE__*/_react["default"].createContext();
exports.MyContext = MyContext;
function Menu(props) {
  var STANDALONE = 'standalone';
  var innerProps = props.innerProps,
    _props$selectProps = props.selectProps,
    alignment = _props$selectProps.alignment,
    classes = _props$selectProps.classes,
    dataMetrics = _props$selectProps.dataMetrics,
    menuWidth = _props$selectProps.menuWidth,
    selectRef = _props$selectProps.selectRef,
    variant = _props$selectProps.variant,
    children = props.children;
  var popperAnchorRef = selectRef.current ? selectRef.current.select.controlRef || selectRef.current.select.select.controlRef : null;
  var calculateMenuWidth = function calculateMenuWidth() {
    return popperAnchorRef ? (popperAnchorRef.clientWidth || 100) - 1 : 100;
  };
  var placementMap = {
    center: 'bottom',
    left: 'bottom-start',
    right: 'bottom-end'
  };
  var actualWidth = calculateMenuWidth();
  var width = menuWidth || actualWidth;
  var menuPopperStyle = {
    backgroundColor: '#ffffff',
    border: '1px solid rgba(0, 0, 0, 0.24)',
    borderRadius: 0,
    boxShadow: '0 3px 5px rgba(0, 0, 0, 0.3)',
    fontSize: 'inherit',
    marginTop: 0,
    minWidth: width,
    opacity: 1,
    padding: 0,
    width: width,
    zIndex: 1301 // This is the minimum zIndex value which beats the zIndex of certain mui components which have had updated zIndexes.
  };

  var isWithMenu = variant !== STANDALONE;
  return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.Menu, (0, _extends2["default"])({}, props, {
    innerProps: _objectSpread({}, innerProps, {
      'data-metrics': dataMetrics.menu
    })
  }), isWithMenu && popperAnchorRef && /*#__PURE__*/_react["default"].createElement(_Popper["default"], (0, _extends2["default"])({
    anchorEl: popperAnchorRef,
    className: classes.paper,
    open: true,
    placement: placementMap[alignment] || placementMap.left,
    style: menuPopperStyle
  }, innerProps), children), (!isWithMenu || !popperAnchorRef) && /*#__PURE__*/_react["default"].createElement(_Paper["default"], (0, _extends2["default"])({
    square: true,
    className: classes.paper
  }, innerProps), children));
}